export function authHeader() {
    return { 'Authorization': 'Bearer ' + process.env.VUE_APP_BASE_API_TOKEN };
}

export function authHeaderWithToken(token) {
    return { 'Authorization': `Bearer ${token}` };
}